import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShieldCheck } from 'lucide-react';
import { LEGAL_TEXTS } from '../../lib/legalTexts';

interface LegalModalProps {
    isOpen: boolean;
    onClose: () => void;
    type: keyof typeof LEGAL_TEXTS | null;
}

const LegalModal: React.FC<LegalModalProps> = ({ isOpen, onClose, type }) => {
    if (!type) return null;

    const data = LEGAL_TEXTS[type];

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.95, y: 20 }}
                        className="bg-white dark:bg-gray-900 w-full max-w-2xl max-h-[80vh] rounded-[2rem] overflow-hidden shadow-2xl relative border border-gray-100 dark:border-gray-800 flex flex-col"
                    >
                        {/* Header */}
                        <div className="p-8 border-b border-gray-50 dark:border-gray-800 flex items-center justify-between bg-gray-50/50 dark:bg-gray-800/50">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-xl bg-blue-500/10 flex items-center justify-center text-blue-600">
                                    <ShieldCheck size={24} />
                                </div>
                                <h2 className="text-xl font-black text-gray-950 dark:text-white uppercase tracking-tighter">
                                    {data.title}
                                </h2>
                            </div>
                            <button
                                onClick={onClose}
                                className="w-10 h-10 rounded-full bg-white dark:bg-gray-800 shadow-sm border border-gray-100 dark:border-gray-700 flex items-center justify-center text-gray-400 hover:text-gray-950 dark:hover:text-white transition-colors"
                            >
                                <X size={20} />
                            </button>
                        </div>

                        {/* Content */}
                        <div className="p-8 overflow-y-auto custom-scrollbar flex-1 whitespace-pre-wrap leading-relaxed text-sm text-gray-600 dark:text-gray-400 font-medium">
                            {data.content}

                            <div className="mt-8 p-6 bg-blue-50 dark:bg-blue-900/10 rounded-2xl border border-blue-100 dark:border-blue-900/30">
                                <p className="text-[10px] uppercase font-black tracking-widest text-blue-600 dark:text-blue-400 mb-2">Resmi Uyarı</p>
                                <p className="text-[11px] text-blue-900/60 dark:text-blue-300/60">
                                    Bu metin FastCashTrade platformu üzerindeki yasal hak ve yükümlülüklerinizi tanımlar. Platformu kullanarak bu şartları kabul etmiş sayılırsınız. Şüphe duyduğunuz konularda hukuk müşavirine danışmanızı öneririz.
                                </p>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="p-6 bg-gray-50 dark:bg-gray-800/50 border-t border-gray-50 dark:border-gray-800 flex justify-end">
                            <button
                                onClick={onClose}
                                className="px-8 py-3 bg-gray-950 dark:bg-white text-white dark:text-gray-950 rounded-2xl font-black text-xs uppercase tracking-widest hover:scale-105 active:scale-95 transition-all shadow-lg active:shadow-sm"
                            >
                                Anladım
                            </button>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default LegalModal;
